import { ComputedRef } from 'vue'

export const requiredRule = (val: string) => !!val || 'Field is required'
export const nonNegativeRule = (val: number) => (val >= 0) || 'Field must have value 0 or higher'
export const numberOnlyRule = (val: string) => /^[\d,.]+$/.test(val) || 'Only accepts numbers'
export const passwordRule = (val: string) => (val?.length > 4) || 'Password must contain minimum 5 characters'
export const repeatPasswordRule = (password: ComputedRef<string | undefined>) => (val: string) => (val === password.value) || 'Passwords differs from each other'

export const numberFieldRangeRule = (min: number, max: number) => (val: string) => {
    const toNum = Number(val).valueOf()
    return (toNum <= max && toNum >= min) || `Number should be in range ${min}-${max}`
}
